<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div v-if="loading" class="loading-container">
            <RotateSquare
              class="loading-position animated fadeIn"
              size="60px"
            ></RotateSquare>
          </div>
          <div v-else class="card-body">
            <h4>{{ $t("sectionAcesso.acessoTitle") }}</h4>
            <b-table
              :hover="true"
              responsive
              :items="itens"
              :fields="fields"
              striped
              show-empty
              :empty-text="$t('textNenhumResultado')"
            >
              <template v-slot:empty="scope">
                <h4>{{ scope.emptyText }}</h4>
              </template>
              <template v-slot:cell(dataAcesso)="data">
                <div class="center">
                  <label for>{{
                    new Date(data.item.dataAcesso).toLocaleString()
                  }}</label>
                </div>
              </template>
              <template v-slot:cell(dataExpiracao)="data">
                <div class="center">
                  <label for>{{
                    new Date(data.item.dataExpiracao).toLocaleString()
                  }}</label>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "RelatorioAcesso",
  components: { RotateSquare },
  data() {
    return {
      locale: this.$i18n.locale,
      loading: false,
      itens: []
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "nome",
          label: this.$t("sectionAcesso.acessoLabelNome"),
          sortable: true
        },
        {
          key: "email",
          label: this.$t("sectionAcesso.acessoLabelEmail"),
          sortable: true
        },
        {
          key: "dataAcesso",
          label: this.$t("sectionAcesso.acessoLabelDataAcesso"),
          sortable: true
        },
        {
          key: "dataExpiracao",
          label: this.$t("sectionAcesso.acessoLabelDataExpiracao"),
          sortable: true
        }
      ];
    }
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    }
  },
  mounted() {
    this.ObterGrid();
  },
  created() {},
  methods: {
    ObterGrid() {
      this.loading = true;
      this.$http({
        url:
          "/relatorio/acesso/" +
          this.$store.getters.getAutenticacao.contaSelecionadaId,
        method: "GET"
      })
        .then((response) => {
          this.itens = response.data;
          this.loading = false;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>
